import { useTranslations } from '@vocab/react';
import { Box, ButtonLink } from 'braid-design-system';

import { createUpgradeLink } from 'src/App/components/JobActions/links';
import { UpgradeIcon } from 'src/App/components/UpgradeButton/UpgradeIcon';
import { EVENT_NAME_JOB_UPGRADED_BUTTON_PRESSED } from 'src/App/constants/tracking';
import { useConfig } from 'src/hooks/useConfig';
import { useTracking } from 'src/hooks/useTracking';
import type { Job } from 'src/types';

import translations from './.vocab';

interface UpgradeButtonProps {
  job: Job;
}

export const UpgradeButton: React.FC<
  React.PropsWithChildren<UpgradeButtonProps>
> = ({ job }) => {
  const { t } = useTranslations(translations);
  const { urlResolver } = useConfig();
  const { trackEvent } = useTracking();

  const upgradeLink = urlResolver({
    path: createUpgradeLink(job),
  });

  const onClick = () => {
    trackEvent(EVENT_NAME_JOB_UPGRADED_BUTTON_PRESSED, {
      jobId: job.jobId,
    });
  };

  return (
    <ButtonLink
      href={upgradeLink}
      size="small"
      tone="brandAccent"
      onClick={onClick}
    >
      <Box display="flex" alignItems="center">
        {t('upgrade')}
        <Box display="flex" paddingLeft="small">
          {/* This icon may be available through Braid at a later date */}
          <UpgradeIcon />
        </Box>
      </Box>
    </ButtonLink>
  );
};
